export const TipoTramiteConstants = {
  ID_TRAMITE_OBTENTOR_VARIEDAD_VEGETAL: 3,
  ID_TRAMITE_SIC_PROIND_COMDES: 1,
  ID_TRAMITE_SIC_COMP_DES: 12,
  ID_TRAMITE_SIC_PROP_IND: 13,
};

export const AsuntoTramiteConstants = {
  ID_ASUNTO_SIC_COMP_DES: 1,
  ID_ASUNTO_SIC_PROP_IND: 2,
  ID_ASUNTO_SIC_PROIND_COMDES: 3,
};
